<template>
  <split-panel-page :showRight="false" class="scroll-vertical full">
    <content-nav-bar>
      <h5 class="is-size-4 level-item">Create Organization</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Creating Organization</loader>
    </content-nav-bar>
    <div class="field org-form">
      <form-field icon="name" title="Name">
        <input v-model="name"
          class="input"
          type="text"
          placeholder="Organization Name">
      </form-field>

      <form-field icon="description" title="Organization Description">
        <textarea
          v-model="description"
          class="textarea"
          type="text"
          placeholder="Description"></textarea>
      </form-field>

      <form-field icon="org" :title="`Domain ( Vanity Domain: ${vanity}.ongameplan.com )`">
        <input v-model="hd"
          class="input"
          type="text"
          placeholder="e.g. digitasecurity.com">
      </form-field>

      <!-- <form-field icon="web" title="Vanity Domain Prefix (*.gp.digitasec.com)">
        <input v-model="vanity"
          class="input"
          type="text"
          placeholder="e.g. digita">
      </form-field> -->

      <fieldset class="fieldset">
        <legend>Users</legend>
        <div class="level">
          <div class="level-left">
            <a v-on:click="addUser()" class="button add snapshot-button">
              <i class="fas fa-plus"></i>
              Add User
            </a>
            <b-checkbox v-model="createUsers">
              Create Passwordless Users on Auth0
            </b-checkbox>
          </div>
        </div>
      <div
        v-for="user in users"
        :key="user.key"
        class="field is-horizontal header-row">
        <a
          v-on:click="removeUser(user.key)"
          class="button button-inverse full-height">
          <i class="fas fa-times"></i>
        </a>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input v-model="user.value"
                class="input"
                type="text"
                placeholder="e.g. user@digitasecurity.com">
            </div>
          </div>
        </div>
      </div>
      </fieldset>
      <fieldset class="fieldset">
        <legend>Login Config</legend>
        <a v-on:click="addConnector('', 'default_button')" class="button add snapshot-button">
          <i class="fas fa-plus"></i>
          Add Custom Connector
        </a>
        <a v-on:click="addConnector('email', '')" class="button add snapshot-button">
          <i class="fas fa-plus"></i>
          Add Passwordless Connector
        </a>
        <a
          v-on:click="addConnector('google-oauth2', 'google_button')"
          class="button add snapshot-button">
          <i class="fas fa-plus"></i>
          Add Google Connector
        </a>
        <a
          v-on:click="addConnector('AzureADv2', 'azure_button')"
          class="button add snapshot-button">
          <i class="fas fa-plus"></i>
          Add Azure Connector
        </a>
        <div
          v-for="login in logins"
          :key="login.key"
          class="field is-horizontal header-row">
          <div class="level">
            <a
              v-on:click="removeConnector(login.key)"
              class="button button-inverse full-height">
              <i class="fas fa-times"></i>
            </a>
            <div class="level-left">
              <input v-model="login.connector"
                  class="input level-item small-width"
                  type="text"
                  placeholder="e.g. google-oauth2">
              <input v-model="login.button"
                  class="input level-item small-width"
                  type="text"
                  placeholder="e.g. google_button">
              <svgicon
                class="level-item" :name="login.button" :original="true" width="185" height="40">
              </svgicon>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <!-- <template slot="right">
      <content-nav-bar>
        <h5 class="is-size-4 has-text-centered level-item">Login Page</h5>
        <login :loginsProp="loginsConfig.logins"></login>
      </content-nav-bar>
    </template> -->
  </split-panel-page>
</template>

<script>
import _ from 'lodash';
import utils from '@/mixins/utils';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';
import SplitPanelPage from '@/components/SplitPanelPage.vue';
import FormField from '@/components/forms/FormField.vue';

export default {
  name: 'OrganizationCreate',
  mixins: [utils],
  components: {
    SplitPanelPage,
    ContentNavBar,
    Loader,
    FormField,
  },
  async mounted() {
    // this.packages = await this.$store.dispatch('primary/listPackages');
    // this.profiles = await this.$store.dispatch('primary/listProfiles');
  },
  data() {
    return {
      showLoader: false,
      name: '',
      description: '',
      hd: '',
      users: [],
      logins: [],
      createUsers: false,
    };
  },
  computed: {
    vanity() {
      return this.hd.split('.')[0];
    },
    payload() {
      return {
        name: this.name,
        description: this.description,
        hd: this.hd,
        vanity: this.vanity,
        users: _.map(this.users, u => u.value),
        loginConfig: this.loginsConfig,
        createUsers: this.createUsers,
      };
    },
    loginsConfig() {
      return {
        logins: _.map(this.logins, l => ({
          connector: l.connector,
          button: l.button,
        })),
      };
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const org = await this.$store.dispatch('admin/createOrganization', this.payload);
      this.showLoader = false;
      if (org) {
        this.$router.push({
          name: 'admin.organizations.index.detail',
          params: { id: org.uuid },
        });
      }
    },
    addUser() {
      this.users.push({
        key: this.uuid(),
        value: '',
      });
    },
    removeUser(key) {
      const index = _.findIndex(this.users, { key });
      this.users.splice(index, 1);
    },
    addConnector(connector, button) {
      this.logins.push({
        key: this.uuid(),
        connector,
        button,
      });
    },
    removeConnector(key) {
      const index = _.findIndex(this.logins, { key });
      this.logins.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.org-form {
  padding: $content-padding;

  .field, .fieldset {
    margin-bottom: 1rem;
  }

  .header-row {
    margin-top: 1rem;
  }

  .small-width {
    width: 15rem;
  }

  .button {
    margin-right: .5rem;
  }
}

</style>
